<template>
  <div
    class="border-r-1 border-l-1 border-b-1 shadow-around inset-shadow-sm dark:inset-shadow-neutral-700/20 inset-shadow-white/50 h-13 flex justify-between rounded-b-xl border-gray-100 bg-white/50 px-0.5 py-1 backdrop-blur-md dark:border-neutral-800 dark:bg-neutral-900/90"
    :class="{
      'border-t-1 rounded-t-xl': !$route.name.startsWith('Chess'),
      'rounded-t-[0.25rem]': $route.name.startsWith('Chess'),
    }"
  >
    <div
      class="flex grow justify-around"
      :class="{
        'w-[calc(50%-var(--spacing)*15)]': !ctaHidden,
        'w-[75%]': ctaHidden && (moreHidden || hideFav),
        'w-[100%]': ctaHidden && moreHidden && hideFav,
      }"
    >
      <button
        v-if="catalogSettings?.type === 'InteractiveCatalogue'"
        class="relative flex w-1/2 grow cursor-pointer flex-col items-center justify-between py-0.5"
        @click="
          OPEN_MODAL({
            type: 'filter',
          })
        "
      >
        <lucide-icon icon="Search" :badge="filtersCount" size="22" />
        <span class="text-2xs truncate leading-3">
          {{ $t('titles.Filter') }}
        </span>
      </button>
      <div class="flex w-1/2 grow">
        <Dropdown
          class="grow"
          button-class="h-full  justify-center group cursor-pointer hover:text-primary flex-col  "
          button-content-class="flex flex-col items-center justify-between grow text-2xs leading-3 py-0.5"
          :chevron-size="0"
          :fullscreen="true"
        >
          <template #label-icon>
            <lucide-icon icon="MenuFullHeight" class="" size="22" />
          </template>
          <template #label>
            {{ $t('control.Change view') }}
          </template>
          <template #title> {{ $t('control.Change view') }}</template>
          <template #content="{ closeDropdown }">
            <NavigationMenu
              class="flex-col"
              item-active-class="btn-primary"
              item-class="btn h-10 md:h-9 px-3 hover:bg-gray-100 dark:hover:bg-neutral-700"
              @pageChanged="closeDropdown"
            ></NavigationMenu>
          </template>
        </Dropdown>
      </div>
    </div>
    <div v-if="!ctaHidden" class="shring-0 relative mx-1 w-14">
      <LinksDropdown
        :icon-scale="1.3"
        button-class="size-14 mask-squircle btn-primary cursor-pointer  "
        class="absolute -bottom-0.5 left-0"
      ></LinksDropdown>
    </div>
    <div
      v-if="!hideFav || !moreHidden"
      class="flex grow justify-around"
      :class="{
        'w-[calc(50%-var(--spacing)*15)]': !ctaHidden,
        'w-[25%]': ctaHidden && (moreHidden || hideFav),
      }"
    >
      <router-link
        v-if="catalogSettings?.type === 'InteractiveCatalogue' && !hideFav"
        :to="
          getRouterConfig({
            name: 'Favorites',
          })
        "
        :inert="$route.name.startsWith('Favorites')"
        active-class="active"
        class="hover:text-primary group flex w-1/2 grow cursor-pointer flex-col items-center justify-between py-0.5"
      >
        <lucide-icon
          icon="RPTHeart"
          size="22"
          :badge="favorites.length"
          badge-classes="-top-3 -right-3"
          class="group-[.active]:text-primary"
        />
        <span class="text-2xs truncate leading-3">
          {{ $t('routes.Favorites') }}
        </span>
      </router-link>

      <div v-if="!moreHidden" class="flex w-1/2 grow">
        <Dropdown
          class="grow"
          button-class="h-full  justify-center group cursor-pointer hover:text-primary flex-col  "
          button-content-class="flex flex-col items-center justify-between grow text-2xs leading-3 py-0.5"
          :chevron-size="0"
          :fullscreen="true"
        >
          <template #label-icon>
            <lucide-icon icon="CircleEllipsis" class="" size="22" />
          </template>
          <template #label>
            {{ $t('titles.More') }}
          </template>
          <template #title> {{ $t('titles.More') }}</template>
          <template #content="{ closeDropdown }">
            <LanguageSelect
              v-if="!hideLang"
              button-class="h-10 transition-colors w-full px-3 hover:bg-gray-100 dark:hover:bg-neutral-700 rounded-lg cursor-pointer"
              :chevron-size="0"
              @click.native="closeDropdown"
            ></LanguageSelect>
            <ThemeSelect
              v-if="!hideTheme"
              button-class="h-10 transition-colors w-full px-3 hover:bg-gray-100 dark:hover:bg-neutral-700 rounded-lg cursor-pointer"
              @click.native="closeDropdown"
            ></ThemeSelect>
          </template>
        </Dropdown>
      </div>

      <!-- <a
        class="flex w-1/2 grow cursor-pointer flex-col items-center justify-between py-0.5"
        href="#"
      >
        <lucide-icon icon="CircleEllipsis" size="22" />
        <span class="text-2xs leading-3">
       
        </span>
      </a> -->
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import NavigationMenu from './NavigationMenu.vue';
import LinksDropdown from './LinksDropdown.vue';
import Dropdown from '@/components/ui/Dropdown';
import LanguageSelect from './LanguageSelect.vue';
import ThemeSelect from './ThemeSelect.vue';

import { formatPhoneNumber } from '@dmlnc/hello_world_phone';

export default {
  name: 'HeaderBottom',

  components: {
    NavigationMenu,
    LinksDropdown,
    Dropdown,
    LanguageSelect,
    ThemeSelect,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'favorites',
      'filtersCount',
      'projects',
      'catalogSettings',
      'hideTopBar',
      'hideContacts',
      'hideSocials',
      'hideTheme',
      'hideLang',
      'hideFav',
    ]),

    ctaHidden() {
      return this.hideContacts || this.hideSocials;
    },
    moreHidden() {
      return (this.hideTheme && this.hideLang) || this.hideTopBar;
    },

    mainPhone() {
      return formatPhoneNumber(this.catalogSettings?.contacts.phone);
    },
    secondaryPhone() {
      return formatPhoneNumber(this.catalogSettings?.contacts.secondary_phone);
    },
  },
  watch: {
    // async catalogSettings() {},
  },

  async mounted() {},

  beforeDestroy() {
    // window.removeEventListener('resize', this.onResize);
    // if (this.interval != null) {
    //   clearInterval(this.interval);
    //   this.interval = null;
    // }
  },

  methods: {
    ...mapActions(['OPEN_MODAL']),
  },
};
</script>
<style lang="scss"></style>
